<div class="background">
    <picture>
        <source srcset="/static/footer_trees_w3500.webp" media="(min-width: 3500px)" />
        <source srcset="/static/footer_trees_w3500.png" media="(min-width: 3500px)" />
        <source srcset="/static/footer_trees_w2000.webp" media="(min-width: 2000px)" />
        <source srcset="/static/footer_trees_w2000.png" media="(min-width: 2000px)" />
        <source srcset="/static/footer_trees_w1400.webp" />
        <source srcset="/static/footer_trees_w1400.png" />
        <!-- svelte-ignore a11y-missing-attribute -->
        <img src="/static/footer_trees_w1400.png" class="background-footer" />
    </picture>
</div>
